import type { QuantityOption } from '@/shared/config';

// Label for the "show all" quantity option, per active subtab.
export const SHOW_ALL_LABEL_BY_TAB: Record<string, string> = {
  modelos: 'Todos os modelos',
  rascunhos: 'Todos os rascunhos',
  reprovados: 'Todos os registros',
  'lista-registros': 'Todos os Registros',
};

/**
 * Returns the quantity options with the "show all" entry (matched by
 * `showAllId`) relabelled for the active subtab. All other options are kept
 * untouched.
 */
export const buildQuantityOptions = (
  baseOptions: QuantityOption[],
  showAllId: number,
  tab: string
): QuantityOption[] =>
  baseOptions.map((option) =>
    option.id === showAllId
      ? { ...option, name: SHOW_ALL_LABEL_BY_TAB[tab] ?? SHOW_ALL_LABEL_BY_TAB.modelos }
      : option
  );
